import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { createSlice } from "@reduxjs/toolkit";
var initialState = {
    data: null,
    isFetching: false,
    isError: false,
    requestKey: null
};
var getDataAllCatalogSlice = createSlice({
    name: "getDataAllCatalog",
    initialState: initialState,
    reducers: {
        fetchData: function(state, action) {
            state.isFetching = true;
            state.data = null;
            state.isError = false;
            state.requestKey = action.payload;
        },
        fetchDataSuccess: function(state, action) {
            if (state.requestKey !== action.payload.requestKey) {
                return state;
            }
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                data: action.payload.data
            });
        },
        fetchDataFailure: function(state, action) {
            if (state.requestKey !== action.payload) {
                return state;
            }
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                isError: true
            });
        },
        resetState: function() {
            return initialState;
        }
    }
});
var _getDataAllCatalogSlice_actions = getDataAllCatalogSlice.actions;
export var fetchData = _getDataAllCatalogSlice_actions.fetchData, fetchDataSuccess = _getDataAllCatalogSlice_actions.fetchDataSuccess, fetchDataFailure = _getDataAllCatalogSlice_actions.fetchDataFailure, resetState = _getDataAllCatalogSlice_actions.resetState;
export default getDataAllCatalogSlice.reducer;
